export default __webpack_public_path__ + "static/media/Matilda 9781408316788.55087831.jpg";